/** RudderStack destination config field aliases (canonical key first). */
export const RS_HOST_KEYS = ['host'] as const;
export const RS_PORT_KEYS = ['port'] as const;
export const RS_USER_KEYS = ['user', 'username'] as const;
export const RS_NAMESPACE_KEYS = ['namespace', 'schema'] as const;
export const RS_CLUSTER_ID_KEYS = ['clusterId', 'clusterIdentifier'] as const;
export const RS_REGION_KEYS = ['clusterRegion', 'region'] as const;
export const RS_ROLE_ARN_KEYS = ['iamRoleARNForAuth', 'iamRoleArnForAuth', 'iamRoleArn'] as const;
export const RS_IAM_FLAG_KEYS = ['useIAMForAuth', 'useIamForAuth', 'iamAuth', 'iamAuthEnabled'] as const;

export function pickUnknown(record: Record<string, unknown>, keys: readonly string[]): unknown {
  for (const key of keys) {
    if (Object.hasOwn(record, key)) return record[key];
  }
  return undefined;
}

/** First non-empty trimmed string value for any of the given keys. */
export function pickString(record: Record<string, unknown>, keys: readonly string[]): string | undefined {
  for (const key of keys) {
    if (!Object.hasOwn(record, key)) continue;
    const value = record[key];
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed) return trimmed;
    }
  }
  return undefined;
}

/** First own-property port as a trimmed string (accepts string or finite number). */
export function pickPortString(record: Record<string, unknown>, keys: readonly string[]): string | undefined {
  for (const key of keys) {
    if (!Object.hasOwn(record, key)) continue;
    const value = record[key];
    if (typeof value === 'number' && Number.isFinite(value)) return String(value);
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed) return trimmed;
    }
  }
  return undefined;
}

/** True for RS IAM auth flags in common boolean/string forms. */
export function isRsTruthyFlag(val: unknown): boolean {
  if (typeof val === 'boolean') return val;
  if (typeof val === 'number') return val !== 0;
  if (typeof val !== 'string') return false;
  const normalized = val.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on';
}
